/* import __COLOCATED_TEMPLATE__ from './dining-option-selector-field.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { feature } from '@square/ember-features/macros';
let DiningOptionSelectorField = (_dec = feature('fulfillment/enable-fulfillment-methods-dashboard'), (_class = class DiningOptionSelectorField extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isModalOpen", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "enableFulfillmentMethods", _descriptor3, this);
  }
  get diningOptionsLabel() {
    if (this.args.selectedDiningOptions.length === 0) {
      return this.noDiningOptionsLabel;
    } else if (this.args.selectedDiningOptions.length === 1) {
      const [diningOption] = this.args.selectedDiningOptions;
      return diningOption.name;
    } else if (this.args.selectedDiningOptions.length === this.args.diningOptions.length) {
      return this.allDiningOptionsLabel;
    } else {
      return this.getMultipleDiningOptionsLabel(this.args.selectedDiningOptions.length);
    }
  }
  get selectedDiningOptionIds() {
    return new Set(this.args.selectedDiningOptions.map(diningOption => diningOption.id));
  }
  get options() {
    return this.args.diningOptions.map(diningOption => ({
      checked: this.selectedDiningOptionIds.has(diningOption.id),
      label: diningOption.name,
      value: diningOption.id
    }));
  }
  get modalOptions() {
    return {
      title: this.noDiningOptionsLabel,
      selectAllLabel: this.allDiningOptionsLabel,
      primaryButtonLabel: this.intl.t('sharedUi.common.done'),
      options: this.options,
      enableIndeterminateState: true,
      allowDisablingPrimaryButton: false
    };
  }
  getMultipleDiningOptionsLabel(count) {
    return this.intl.t(this.enableFulfillmentMethods ? 'sharedUi.diningOptionSelectorField.fulfillmentMethod.label.multipleOptions' : 'sharedUi.diningOptionSelectorField.label.multipleOptions', {
      count
    });
  }
  get allDiningOptionsLabel() {
    return this.intl.t(this.enableFulfillmentMethods ? 'sharedUi.diningOptionSelectorField.fulfillmentMethod.label.allOptions' : 'sharedUi.diningOptionSelectorField.label.allOptions');
  }
  get noDiningOptionsLabel() {
    return this.intl.t(this.enableFulfillmentMethods ? 'sharedUi.selectFulfillmentMethods' : 'sharedUi.selectDiningOptions');
  }
  open() {
    this.isModalOpen = true;
  }
  closeModal(event) {
    this.isModalOpen = false;
    if (!Array.isArray(event)) {
      return;
    }
    const selectedDiningOptionIds = event.reduce((selectedDiningOptionIds, {
      value,
      checked
    }) => {
      if (checked) {
        selectedDiningOptionIds.add(value);
      }
      return selectedDiningOptionIds;
    }, new Set());
    this.args.onChange(selectedDiningOptionIds);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "enableFulfillmentMethods", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "open", [action], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype)), _class));
export { DiningOptionSelectorField as default };